import { colorsPalettes } from '@similarweb/styles';

import type { TechnologyOption } from '../../../../domain/technology';

import {
  StyledTechCategoryLabel,
  StyledTechCategoryOption,
  StyledTechCategoryCheckbox,
  StyledTechCategoryIcon,
} from './styles';

export const TechCategoryDropdownOption = ({
  option,
  onTechnologiesSelect,
  selectedCategories,
}: {
  option: TechnologyOption;
  onTechnologiesSelect(option: TechnologyOption): void;
  selectedCategories: string[];
}) => {
  const { name, isChild, count, items } = option;
  const isFullyChecked = isChild
    ? selectedCategories.includes(name)
    : items.every((item) => selectedCategories.includes(item));

  const isHalfChecked = isChild ? false : !isFullyChecked && items.some((item) => selectedCategories.includes(item));

  return (
    <StyledTechCategoryCheckbox
      isChecked={isFullyChecked}
      isHalfChecked={isHalfChecked}
      labelFirst
      onClick={() => onTechnologiesSelect(option)}
      isChild={isChild}
      label={
        <StyledTechCategoryOption isChild={isChild}>
          {!isChild ? (
            <StyledTechCategoryIcon iconName="category" iconColor={colorsPalettes.carbon[200]} size="sm" />
          ) : null}
          <StyledTechCategoryLabel>
            <span>{name}</span>
            <span>{count}</span>
          </StyledTechCategoryLabel>
        </StyledTechCategoryOption>
      }
    />
  );
};
